export default __webpack_public_path__ + "594b77cd1be522647e3a63164cb7fa0d.png";